export enum Pages {
    PlayerManager,
    Game,
    Summary,
}
